import { Box, Button, Modal, SpaceBetween } from "@cloudscape-design/components";
import { ReactNode } from "react";

interface DeleteConfirmModalProps {
  visible: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
  loading?: boolean;
  header?: string;
  itemName?: string;
  children?: ReactNode;
}

/**
 * Generic, presentational delete-confirmation modal shared across pages.
 *
 * It performs no API calls itself — the parent supplies `onConfirm` and owns the
 * actual delete logic and loading state. Body text defaults to a standard
 * `Are you sure you want to delete "{itemName}"?` message when `itemName` is
 * provided, otherwise the supplied `children` are rendered as the body.
 */
export default function DeleteConfirmModal({
  visible,
  onDismiss,
  onConfirm,
  loading = false,
  header = "Delete",
  itemName,
  children,
}: DeleteConfirmModalProps) {
  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      header={header}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onDismiss}>Cancel</Button>
            <Button variant="primary" onClick={onConfirm} loading={loading}>Delete</Button>
          </SpaceBetween>
        </Box>
      }
    >
      {itemName !== undefined ? `Are you sure you want to delete "${itemName}"?` : children}
    </Modal>
  );
}
